if (!customElements.get('base-grid-density')) {
  customElements.define(
    'base-grid-density',
    class BaseGridDensity extends HTMLElement {
      static STORAGE_KEY = 'base:grid-density';

      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-density]'));
        this.comfortable = Number(this.dataset.comfortable) || 4;
        this.compact = Number(this.dataset.compact) || 5;

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.apply(button.dataset.density, true));
        });

        this.apply(this.stored || 'comfortable', false);
        this.watchGrid();

        document.addEventListener('shopify:section:load', () => this.apply(this.current, false));
      }

      /**
       * O facets.js do Dawn troca o innerHTML de #ProductGridContainer via AJAX
       * a cada filtro aplicado, e o <ul id="product-grid"> volta com as classes
       * originais da section. Não há evento público depois do render, então
       * observamos o container e reaplicamos a densidade no novo nó.
       */
      watchGrid() {
        const container = document.getElementById('ProductGridContainer');
        if (!container || !('MutationObserver' in window)) return;

        this.gridObserver = new MutationObserver(() => {
          const grid = this.grid;
          if (!grid || grid === this.lastGrid) return;
          this.lastGrid = grid;
          this.apply(this.current, false);
        });

        this.lastGrid = this.grid;
        this.gridObserver.observe(container, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.gridObserver?.disconnect();
      }

      get stored() {
        try {
          return localStorage.getItem(BaseGridDensity.STORAGE_KEY);
        } catch (error) {
          // Safari em navegação privada bloqueia localStorage.
          return null;
        }
      }

      set stored(value) {
        try {
          localStorage.setItem(BaseGridDensity.STORAGE_KEY, value);
        } catch (error) {
          /* preferência só não persiste entre páginas */
        }
      }

      get grid() {
        return document.getElementById('product-grid');
      }

      apply(density, persist) {
        const grid = this.grid;
        if (!grid) return;

        const valid = ['comfortable', 'compact', 'list'];
        this.current = valid.includes(density) ? density : 'comfortable';

        const columns = this.current === 'list' ? 1 : this.current === 'compact' ? this.compact : this.comfortable;

        // Remove qualquer grid--N-col-desktop antes de aplicar o novo.
        grid.className = grid.className.replace(/\bgrid--\d+-col-desktop\b/g, '').trim();
        grid.classList.add(`grid--${columns}-col-desktop`);
        grid.classList.toggle('base-density-list', this.current === 'list');

        this.buttons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.density === this.current));
        });

        if (persist) this.stored = this.current;
      }
    }
  );
}
